import { AbstractControl } from '@angular/forms';
import { AlarmRuleActionType } from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { AlarmRuleActionFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleAction } from '../base-rule-action';
import { CreateAlarmAction } from './create-alarm-action';

export class CreateAlarmRuleAction extends BaseRuleAction {
  public getDescription(): string {
    return 'common.alarm-rule.action.create-alarm.description';
  }

  public getIcon(): string {
    return 'alarm_add';
  }

  public getName(): string {
    return 'common.alarm-rule.action.create-alarm.title';
  }

  public getType(): AlarmRuleActionType {
    return AlarmRuleActionType.CREATE_ALARM;
  }

  public getEditorComponent(): any {
    return CreateAlarmAction;
  }

  public override configToFrom(data: {}): Record<string, unknown> {
    return {};
  }

  public formToConfig(form: AlarmRuleActionFormDto): Record<string, unknown> {
    return {};
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {};
  }
}